// extracted by mini-css-extract-plugin
export var $animation_name = "GermanyCta-module--$animation_name--201de";
export var GermanyCta = "GermanyCta-module--GermanyCta--ad899";
export var GermanyCta__links = "GermanyCta-module--GermanyCta__links--e0409";
export var GermanyCta__row = "GermanyCta-module--GermanyCta__row--e176d";
export var Inner = "GermanyCta-module--Inner--a0b4c";